import * as motion from "motion/react-client";
import { appearanceAnimation } from "../../../utils/animations";
// import { LazyLoadImage } from "react-lazy-load-image-component";
// import "react-lazy-load-image-component/src/effects/blur.css";
import { useTranslation } from "react-i18next";
import { NewsCard } from "../../../components";
import { Pagination } from "antd";
import { useEffect, useState } from "react";
import axiosInstance from "../../../api/config/axiosConfig";

const NewsPage = () => {
  const { t } = useTranslation();
  const [newsList, setNewsList] = useState<INews[]>([]);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const fetchNews = async () => {
      // const response = await newsServices.getNews(currentPage);
      const response = await axiosInstance.get(`/news?page=${currentPage}`);
      // if (response.error) {
      //   console.error(response.error);
      //   return;
      // }

      setNewsList(response.data.posts);
    };

    fetchNews();
  }, [currentPage]);

  return (
    <div className="w-full flex justify-center items-center px-6 py-20">
      <div className="w-full max-w-[1290px] flex flex-col gap-28 justify-center items-center">
        {/* Title */}
        <motion.div
          {...appearanceAnimation("bottom")}
          className="flex flex-col justify-center items-center gap-6"
        >
          <p className="text-[#074799] md:text-5xl text-3xl font-bold lowercase first-letter:uppercase">
            {t("header.navbar.news")}
          </p>
        </motion.div>

        <div className="w-full grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6">
          {newsList.map((news, index) => (
            <NewsCard key={index} news={news} t={t} />
          ))}
        </div>

        {/* Pagination */}
        <Pagination
          className="mt-10"
          current={currentPage}
          onChange={setCurrentPage}
          total={newsList.length}
          showSizeChanger={false}
        />
      </div>
    </div>
  );
};

export default NewsPage;
